<ng-container *ngIf="data.fields.Title.value !== ''">
  <div mat-dialog-title>
    <span class="dialog-title-label" *scText="data.fields.Title"></span>
    <button
      *ngIf="data.fields.HasCloseButtonInHeader.value"
      (click)="dialogRef.close()"
      class="btn btn-default"
    >
      <i class="icon-close"></i>
    </button>
  </div>
</ng-container>
<div mat-dialog-content>
  <ab-address-book
    [items]="items"
    [data]="data.data.dialogData"
    [securityAddressBook]="securityAddressBook"
    (onSelect)="select($event)"
    [personalTabNotPermission]="personalTabNotPermission"
    [internalTransferDisabled]="internalTransferDisabled"
    [externalTransferDisabled]="externalTransferDisabled"
    [billTransferDisabled]="billTransferDisabled"
  ></ab-address-book>
</div>

<ng-template #personalTabNotPermission>
  <ab-access-denied
    class="small"
    [stopTimer]="true"
    [rendering]="items.personalAccessDenied"
  ></ab-access-denied>
</ng-template>

<ng-template #internalTransferDisabled>
  <ab-access-denied
    class="small"
    [stopTimer]="true"
    [rendering]="items.ownAccountAccessDenied"
  ></ab-access-denied>
</ng-template>

<ng-template #externalTransferDisabled>
  <ab-access-denied
    class="small"
    [stopTimer]="true"
    [rendering]="items.beneficiariesAccessDenied"
  ></ab-access-denied>
</ng-template>

<ng-template #billTransferDisabled>
  <ab-access-denied
    class="small"
    [stopTimer]="true"
    [rendering]="items.companiesAccessDenied"
  ></ab-access-denied>
</ng-template>
